import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import Produits from "./pages/Produits";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Incendie from "./pages/Incendie";
import Petroliers from "./pages/Petroliers";
import Lavage from "./pages/Lavage";
import Tuyauterie from "./pages/Tuyauterie";
import ProductDetailTuyauterie from "./pages/ProductDetailTuyauterie";
import ProductDetailLavage from "./pages/ProductDetailLavage";
import ProductDetailPetrolier from "./pages/ProductDetailPetrolier";
import ProductDetailIncendie from "./pages/ProductDetailIncendie";
import ProductDetailHydraulique from "./pages/ProductDetailHydroliques";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Dashboard from "./pages/Dashboard";
import Robinetterie from "./pages/Robinetterie";
import ProductDetailRobinetterie from "./pages/ProductDetailRobinetterie";
import Hydrauliques from "./pages/Hydrauliques";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Header />
      <div>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/produits" element={<Produits />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/incendie" element={<Incendie />} />
          <Route path="/lavage" element={<Lavage />} />
          <Route path="/petroliers" element={<Petroliers />} />
          <Route path="/hydraulique" element={<Hydrauliques />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/petrolier/:id" element={<ProductDetailPetrolier />} />
          <Route path="/hydraulique/:id" element={<ProductDetailHydraulique />} />
          <Route path="/incendie/:id" element={<ProductDetailIncendie />} />
          <Route path="/lavage/:id" element={<ProductDetailLavage />} />
          <Route path="/robinetterie" element={<Robinetterie />} />
          <Route path="/robinetterie/:id" element={<ProductDetailRobinetterie />} />
          <Route path="/tuyauterie/:id" element={<ProductDetailTuyauterie />} /> {/* ✅ ajouté */}
          <Route path="/tuyauterie" element={<Tuyauterie />} />   



          {/* Routes protégées pour les admins */}
          <Route path="/admin/dashboard" element={<Dashboard />} />

        </Routes>
      </div>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
